// import React from 'react';

import config from "../coreFiles/config"

function Footer() {
	return (
		<>
			<div className="container-fluid bg-secondary text-white mt-5 py-5 px-sm-3 px-md-5">
				<div className="row pt-5">
					<div className="col-lg-4 col-md-6 mb-5">
						<a
							href=""
							className="navbar-brand font-weight-bold text-primary m-0 mb-4 p-0"
						>
							{/* <i className="flaticon-043-teddy-bear" />
							<span className="text-white">SVHS</span> */}

<img
              className="img-fluid" style={{width:'75px', height:'75px'}}
              src="assets/img/logo.png"
              alt=""
            />
						<span className="text-white schoolNameBottom">&nbsp; Swami Vivekanand 
						<small> High School</small>
						 </span>
						</a>
						<p>
							Labore dolor amet ipsum ea, erat sit ipsum duo eos. Volup amet ea dolor
							et magna dolor, elitr rebum duo est sed diam elitr. Stet elitr stet diam
							duo eos rebum ipsum diam ipsum elitr.
						</p>
						{/* <div className="d-flex justify-content-start mt-4">
							<a
								className="btn btn-outline-primary rounded-circle text-center mr-2 px-0"
								style={{ width: 38, height: 38 }}
								href="#"
							>
								<i className="fab fa-twitter" />
							</a>
							<a
								className="btn btn-outline-primary rounded-circle text-center mr-2 px-0"
								style={{ width: 38, height: 38 }}
								href="#"
							>
								<i className="fab fa-facebook-f" />
							</a>
							<a
								className="btn btn-outline-primary rounded-circle text-center mr-2 px-0"
								style={{ width: 38, height: 38 }}
								href="#"
							>
								<i className="fab fa-linkedin-in" />
							</a>
							<a
								className="btn btn-outline-primary rounded-circle text-center mr-2 px-0"
								style={{ width: 38, height: 38 }}
								href="#"
							>
								<i className="fab fa-instagram" />
							</a>
						</div> */}
					</div>
					<div className="col-lg-4 col-md-6 mb-5">
						<h3 className="text-primary mb-4">Quick Links</h3>
						<div className="d-flex flex-column justify-content-start">
							<a className="text-white mb-2" href={config.BASE_URL}>
								<i className="fa fa-angle-right mr-2" />
								Home
							</a>
							<a className="text-white mb-2" href="#aboutUs">
								<i className="fa fa-angle-right mr-2" />
								About Us
							</a>
							<a className="text-white mb-2" href="#gallery">
								<i className="fa fa-angle-right mr-2" />
								Gallery
							</a>
							<a className="text-white mb-2" href="#contactUs">
								<i className="fa fa-angle-right mr-2" />
								Contact Us
							</a>
							<a className="text-white mb-2" target="__blank" href={`${config.BASE_URL}admissionForm.html`}>
								<i className="fa fa-angle-right mr-2" />
								Admission Form
							</a>
							<a className="text-white" target="__blank" href={`${config.BASE_URL}result.html`}>
								<i className="fa fa-angle-right mr-2" />
								Result
							</a>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 mb-5">
						<h3 className="text-primary mb-4">Get In Touch</h3>
						<div className="d-flex">
							<h4 className="fa fa-map-marker-alt text-primary" />
							<div className="pl-3">
								<h5 className="text-white">Address</h5>
								<p>Bhaugarh, Chupna Bypass Road, Teh. Dalouda, Dist Mandsaur (MP)</p>
							</div>
						</div>
						<div className="d-flex">
							<h4 className="fa fa-envelope text-primary" />
							<div className="pl-3">
								<h5 className="text-white">Email</h5>
								<p><a href="mailto:vvmbhaugarh614301@Gmail.com"> vvmbhaugarh614301@Gmail.com</a></p>
							</div>
						</div>
						<div className="d-flex">
							<h4 className="fa fa-phone-alt text-primary" />
							<div className="pl-3">
								<h5 className="text-white">Phone</h5>
								<p> Office : &nbsp;
							<a href="tel:07422298023">
									07422298023, 
							</a>
							</p>
							<p> Director : &nbsp;
								<a href="tel:07422298023">
							8827960927 
							</a>
									</p>
								
							
							</div>
						</div>
					</div>
					
				</div>
				<div
					className="container-fluid pt-5"
					style={{ borderTop: "1px solid rgba(23, 162, 184, .2)" }}
				>
					<p className="m-0 text-center text-white">
						{/* ©{" "}
						<a className="text-primary font-weight-bold" href="#">
							Swami Vivekanand Higher Secondry School
						</a> */}
						All Rights Reserved. Designed by
						{" "} <a className="text-primary font-weight-bold" href="whatsapp://send?text=Hello%20!%20Ajay%20(DITS)&amp;phone=+919993243520">
							Ajay Dhakad
						</a>
					</p>
				</div>
			</div>

			<a href="#" className="btn btn-primary p-3 back-to-top"><i className="fa fa-angle-double-up"></i></a>

		</>
	)
}

export default Footer
